import tracking from '../../utils/tracking';

export default class ImageMerryGoRound {
  domRoot: any;
  galleryContainer: any;
  imagesArray: any;
  disableButtons: boolean;
  startedDrag: boolean;
  startingX: number;

  constructor(domRoot: HTMLElement, params: any) {
    this.domRoot = domRoot;
    this.galleryContainer = domRoot.children[0];
    this.imagesArray = params.imagesArray;
    this.disableButtons = false;
    this.startedDrag = false;
    this.startingX = 0;
    this.init();
  }

  init() {
    this.domRoot.addEventListener("click", (e: MouseEvent) => {
      if (e.target.classList.contains("arrow") && !this.disableButtons) {
        this.advanceImages(e.target.getAttribute("data-dir"));
      }
      if (e.target !== this.galleryContainer) {
        this.dragEnd(e);
      }
    });

    this.galleryContainer.ontouchstart = (e: PointerEvent) => {
      e.preventDefault();
      this.dragStart(e);
      return false;
    };
    this.galleryContainer.ontouchmove = (e: PointerEvent) => {
      this.drag(e);
    };
    this.galleryContainer.ontouchend = (e: PointerEvent) => {
      e.preventDefault();
      this.dragEnd(e);
      return false;
    };

    this.galleryContainer.onmousedown = (e: MouseEvent) => { this.dragStart(e) };
    this.galleryContainer.onmouseup = (e: MouseEvent) => { this.dragEnd(e) };
    this.galleryContainer.onmousemove = (e: MouseEvent) => { this.drag(e) };
  }

  dragStart(e: MouseEvent | PointerEvent) {
    this.startingX = e.screenX ? e.screenX : e.targetTouches[0].pageX;
    this.startedDrag = true;
  }

  drag(e: MouseEvent | PointerEvent) {
    let screenX = e.screenX ? e.screenX : e.targetTouches[0].pageX;
    if (this.startedDrag && this.startingX !== screenX) {
      let isNegative = this.startingX > screenX;
      let difference = screenX - this.startingX;
      this.galleryContainer.style.transform = `translate(${(isNegative ? "-" : "")}3%)`;
      if (Math.abs(difference) > 50) {
        this.dragEnd(e);
        this.advanceImages(isNegative ? "left" : "right", true)
      }
    }
  }

  dragEnd(_e: MouseEvent | PointerEvent) {
    setTimeout(() => {
      this.galleryContainer.style.transform = 'translate(0)';
    }, 1000)
    this.startedDrag = false;
  }

  advanceImages(direction: string, dragged?: boolean) {
    this.disableButtons = true;
    let domItems = this.galleryContainer.children;
    let arithmetic = direction == "left" ? 1 : -1;
    let itemToRemove = direction == "left" ? domItems[0] : domItems[domItems.length - 1];
    let newAddSibling = direction == "left" ? domItems[domItems.length - 1] : domItems[0];
    let itemToAdd = Number(newAddSibling.getAttribute("data-index")) + arithmetic;
    if (itemToAdd < 0) {
      itemToAdd = this.imagesArray.length - 1;
    } else if (itemToAdd >= this.imagesArray.length) {
      itemToAdd = 0;
    }
    let newItem = document.createElement("div");
    newItem.className = "image-item show";
    newItem.setAttribute("data-index", itemToAdd);
    newItem.innerHTML = `<div class="inner">
      <img src="${this.imagesArray[itemToAdd].image}" alt="${this.imagesArray[itemToAdd].title}">
    </div>
    <h4>${this.imagesArray[itemToAdd].title}</h4>`;

    itemToRemove.classList.add("hide");
    if (direction == "left") {
      this.galleryContainer.appendChild(newItem);
    } else {
      this.galleryContainer.insertBefore(newItem, newAddSibling);
    }

    tracking.trackEvent("carousel_" + direction + "_" + (dragged ? "scroll" : "arrow"), {});

    setTimeout(() => {
      if (this.galleryContainer.contains(itemToRemove)) {
        this.galleryContainer.removeChild(itemToRemove);
        this.disableButtons = false;
      }
    }, 150)
  }
}
